import * as React from 'react';

import {useGetBucketedReportData} from 'shells/utils/hooks/use-get-bucketed-report-data';
import type {UnmappedReportData} from 'shells/utils/hooks/use-get-bucketed-report-data';

export type TrafficReportData = {
    bucket: string;
    count: number;
    percent: number;
    segments: any[];
}[];

export const useGetCompetitorTrafficReport = (
    monthsAgo: number
): {
    isLoading: boolean;
    isError: boolean;
    trafficReportData: TrafficReportData | null | undefined;
} => {
    const mapBucketsFunction = (data: UnmappedReportData) => ({
        bucket: data.bucket,
        count: Math.round(data.count.value),
        percent: data.count.percent || 0,
        segments: data.segments,
    });

    // Memoize params
    const params = React.useMemo(
        () => ({
            monthsAgo,
            type: 'trafficBySource',
        }),
        [monthsAgo]
    );

    const {reportData, isLoading, isError} = useGetBucketedReportData({
        reportUrl: 'competitordomains/report',
        params,
        mapBucketsFunction,
    });

    // @ts-expect-error
    return {trafficReportData: reportData, isLoading, isError: Boolean(isError)};
};
